/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_TermsInputs */

const en_signin_terms = /** @type {(inputs: Signin_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By continuing you agree to the Terms and Privacy Policy.`)
};

const id_signin_terms = /** @type {(inputs: Signin_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dengan melanjutkan kamu menyetujui Ketentuan dan Kebijakan Privasi.`)
};

/**
* | output |
* | --- |
* | "By continuing you agree to the Terms and Privacy Policy." |
*
* @param {Signin_TermsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_terms = /** @type {((inputs?: Signin_TermsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_TermsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_terms(inputs)
	return en_signin_terms(inputs)
});